export default function HowToApply() {
  const steps = [
    {
      step: 1,
      title: '提携金融機関口座を準備',
      description: 'このカードの申込みには提携金融機関口座が必要です。お持ちでない方は、専用アプリまたは店舗で口座開設してください。'
    },
    {
      step: 2,
      title: '公式サイトにアクセス',
      description: 'クレジットカードの公式申込みページにアクセスします。'
    },
    {
      step: 3,
      title: 'カードを選択',
      description: '一般カード、ゴールドカードなど、ご希望のカードを選択します。'
    },
    {
      step: 4,
      title: '必要事項を入力',
      description: 'お名前、住所、勤務先情報、提携金融機関口座情報などを入力します。'
    },
    {
      step: 5,
      title: '審査',
      description: '三菱UFJニコスによる審査が行われます。'
    },
    {
      step: 6,
      title: 'カード発行・お届け',
      description: '審査通過後、クレジットカードがご自宅に届きます。届いたらWEBエントリーをお忘れなく！'
    }
  ];

  const documents = [
    '本人確認書類（運転免許証、マイナンバーカード等）',
    '提携金融機関口座情報（支店名、口座番号）',
    '勤務先情報（会社名、電話番号、勤続年数等）',
    '年収情報'
  ];

  return (
    <section className="py-16 bg-[#F0FFF4]">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-12 text-center">
          地域密着型クレジットカードの申込み方法
        </h2>

        <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
          <h3 className="text-xl font-bold text-[#003366] mb-6">申込みの流れ</h3>
          <div className="space-y-6">
            {steps.map((item, index) => (
              <div key={index} className="flex items-start gap-4">
                <div className="w-10 h-10 bg-[#00A040] text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">
                  {item.step}
                </div>
                <div className="flex-1 pt-1">
                  <h4 className="font-bold text-[#003366] mb-1">{item.title}</h4>
                  <p className="text-gray-600 text-sm">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8">
          <h3 className="text-xl font-bold text-[#003366] mb-6">必要書類</h3>
          <ul className="space-y-3">
            {documents.map((doc, index) => (
              <li key={index} className="flex items-start gap-3">
                <i className="ri-file-text-line text-[#00A040] flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
                <span className="text-gray-700">{doc}</span>
              </li>
            ))}
          </ul>
          <div className="mt-6 p-4 bg-[#FFF9E6] rounded-lg">
            <p className="text-sm text-[#996600]">
              <i className="ri-information-line mr-1 w-4 h-4 inline-flex items-center justify-center"></i>
              <span className="font-medium">注意：</span>このカードは提携金融機関口座保有者限定です。口座をお持ちでない方は、先に口座開設が必要です。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
